import React, { useState, useRef, useEffect } from "react"
import Modal from "../Modal/Modal"
import style from "./ProfessionalProfile.module.sass"
import camera from "../../../../assets/images/camera.svg"
import trash from "../../../../assets/images/red-trash-without-circle.svg"
import upload from "../../../../assets/images/upload.svg"

function ProfessionalProfile(props) {
  const { avatar, currentProfessional, activeLicenses, logoutUrl, privacyUrl, dpaUrl, translations } = props

  const ref = useRef();
  const avatarForm = useRef()
  const avatarInput = useRef()
  const modalTriggerRef = useRef(null)

  const [imageHover, setImageHover] = useState(false)
  const [showUploadMenu, setShowUploadMenu] = useState(false)
  const [legalUrl, setLegalUrl] = useState(null)

  const openInModal = (url) => {
    const unique = `${url}${url?.includes("?") ? "&" : "?"}rand=${Math.random()
      .toString(36)
      .slice(2)}`
    setLegalUrl(unique)
    // clicco il bottone nascosto dopo aver settato lo state
    setTimeout(() => modalTriggerRef.current?.click(), 0)
  }


  const renderAvatar = () => {
    return (
      <div className={style.professionalAvatar}
        style={avatar.present ? { backgroundImage: `url(${avatar.url})`, backgroundSize: "cover" } : {}}
        onMouseEnter={() => setImageHover(true)}
        onMouseLeave={() => setImageHover(false)}>
        <div className={`${style.changeAvatar} ${imageHover ? "" : "d-none"}`}
          onClick={() => setShowUploadMenu(!showUploadMenu)}>
          <img src={camera} className={style.camera}></img>
          <span className={style.text}>
            {!avatar.present && translations.addAvatar}
            {avatar.present && translations.changeAvatar}
          </span>
        </div>
      </div>
    )
  }

  const activeLicense = (license, expirationDate = false) => {
    if (expirationDate) {
      return (
        <div className={style.infoRow}>
          <div className={style.label}>{translations[license]}</div>
          <div>
            <div className={style.info} style={{ textTransform: "lowercase" }}>
              <span className={style.greenDot}></span>
              {translations.active}
            </div>
            <div className={style.expiryDate}>
              {translations.expiry_date} {expirationDate}
            </div>
          </div>
        </div>
      )

    }
    else {
      return (
        <div className={style.infoRow}>
          <div className={style.label}>{translations[license]}</div>
          <div className={style.info} style={{ textTransform: "lowercase" }}>
            <span className={style.greenDot}></span>
            {translations.active}
          </div>
        </div>
      )
    }
  }

  const notRequiredLicense = (license) => {
    return (
      <div className={style.infoRow}>
        <div className={style.label}>{translations[license]}</div>
        <div className={style.info}>
          {translations.notRequired}
        </div>
      </div>
    )
  }

  // WARNING: the index of the array depends to the ones defined in center.rb in function active_licenses_with_expiration
  const renderLicenseState = (license) => {
    switch (license) {
      case "euleria_lab":
        if (activeLicenses[0].includes("euleria_lab")) {
          return activeLicense(license)
        } else {
          return notRequiredLicense(license)
        }
      case "xclinic":
        if (activeLicenses[1].includes("xclinic")) {
          return activeLicense(license)
        } else {
          return notRequiredLicense(license)
        }
      case "euleria_gym":
        if (activeLicenses[2].includes("euleria_gym")) {
          return activeLicense(license)
        } else {
          return notRequiredLicense(license)
        }
      case "euleria_home":
        if (activeLicenses[3].includes("euleria_home")) {
          return activeLicense(license)
        } else {
          return notRequiredLicense(license)
        }
      case "reacts":
        if (activeLicenses[4].includes("reacts")) {
          return activeLicense(license)
        } else {
          return notRequiredLicense(license)
        }
      case "euleria_mylink":
        if (activeLicenses[5].includes("euleria_mylink")) {
          return activeLicense(license, activeLicenses[4][1])
        } else {
          return notRequiredLicense(license)
        }
      case "euleria_home_cardio":
        if (activeLicenses[6].includes("euleria_home_cardio")) {
          return activeLicense(license)
        } else {
          return notRequiredLicense(license)
        }
    }
  }

  const renderUploadMenu = () => {
    return (
      <div className={style.uploadMenu}
        style={avatar.present ? { top: "-47px" } : { top: "-25px" }}
        ref={ref}>
        <div className={style.upload}
          onClick={() => avatarInput.current.click()}>
          <form action={avatar.uploadPath}
            method="post"
            encType="multipart/form-data"
            className="d-none"
            id="avatar-form"
            ref={avatarForm}>
            <input type="hidden" name="_method" value="patch" />
            <input type="file"
              accept=".jpg, .jpeg, .png, .gif, .webp"
              id="professional[avatar]"
              name="professional[avatar]"
              ref={avatarInput}
              onChange={() => avatarForm.current.submit()} />
          </form>
          <div className={style.iconContainer}>
            <img src={upload} className={style.icon} />
          </div>
          {!avatar.present &&
            <div>
              {translations.updateAvatar}
            </div>
          }
          {avatar.present &&
            <div>
              {translations.changeAvatar}
            </div>
          }
        </div>
        {avatar.present &&
          <a className={style.delete} href={avatar.delete} data-method="delete">
            <div className={style.iconContainer}>
              <img src={trash} className={style.icon} />
            </div>
            <div>
              {translations.deleteAvatar}
            </div>
          </a>
        }
      </div>
    )
  }

  useOnClickOutside(ref, () => setShowUploadMenu(false));

  return (
    <div className={style.professionalProfile}>
      {/* Trigger nascosto per il Modal */}
      <button
        id="open-legal-modal-btn"
        ref={modalTriggerRef}
        className="d-none"
        type="button"
      />
      {showUploadMenu && renderUploadMenu()}

      <div className={style.professionalName}>
        {currentProfessional.fullName}
      </div>

      {renderAvatar()}

      <div className={style.infoRow}>
        <div className={style.label}>{translations.center}</div>
        <div className={style.info}>{currentProfessional.center}</div>
      </div>
      <div className={style.infoRow}>
        <div className={style.label}>{translations.email}</div>
        <div className={style.info}>{currentProfessional.email}</div>
      </div>
      <div className={style.separator}></div>
      <div className={style.licensesState}>
        {translations.licensesState}
      </div>

      {renderLicenseState('euleria_lab')}
      {activeLicenses[1].includes("xclinic") && renderLicenseState('xclinic')}
      {!activeLicenses[1].includes("xclinic") && renderLicenseState('euleria_gym')}
      {renderLicenseState('euleria_home')}
      {renderLicenseState('euleria_home_cardio')}
      {renderLicenseState('euleria_mylink')}

      <div className={style.logout}>
        <a className={`btn ${style.button}`}
          href={logoutUrl}
          data-method="delete">
          {translations.logout}
        </a>
      </div>
      <div className={`${style.extraLinks} ${style.extraLinksSpread}`}  >
        <a
          href={privacyUrl}
          onClick={(e) => { e.preventDefault(); openInModal(privacyUrl) }}
        >
          {translations.privacy || "Privacy"}
        </a>

        <a
          href={dpaUrl}
          onClick={(e) => { e.preventDefault(); openInModal(dpaUrl) }}
        >
          {translations.dpa || "DPA"}
        </a>
      </div>

      <Modal
        triggerButtons={["#open-legal-modal-btn"]}

        closeButtons={["#close-legal-modal-btn"]}
        background
        closeOnBackgroundClick
      >
        <div className={style.legalModal}>
          <div className={style.legalHeader}>
            <div className={style.legalTitle}>

            </div>
            {
              <button id="close-legal-modal-btn" className={style.closeBtn} aria-label="Close">×</button>
            }
          </div>
          <div className={style.legalBody}>
            {legalUrl
              ? <iframe src={legalUrl} title="Legal" frameBorder="0" />
              : <div className={style.legalPlaceholder}>Caricamento…</div>
            }
          </div>
        </div>
      </Modal>
    </div>
  )
}

function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}

export default ProfessionalProfile